"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Rocket = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Rocket = function Rocket(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.295 1.594c2.737 2.737-1.921 7.396-1.921 7.396.515.516-.849 3.69-1.552 5.221a.488.488 0 01-.863.045l-1.597-2.623s-.666.666-1.35-.019L4.274 8.877c-.684-.685-.019-1.35-.019-1.35L1.632 5.93a.488.488 0 01.045-.864C3.21 4.363 6.383 3 6.9 3.515c0 0 4.658-4.659 7.396-1.921zM9.636 6.252c.756.756 1.965.773 2.7.038.735-.735.718-1.944-.038-2.7-.756-.756-1.964-.772-2.7-.037-.735.735-.718 1.943.038 2.7z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.538 12.963c.917-.242 1.11-1.381.44-2.052-.671-.67-1.81-.477-2.052.44-.169.64-.23 1.271.055 1.556.285.286.917.224 1.557.056z",
    fill: "currentColor"
  }));
};

exports.Rocket = Rocket;
var _default = Rocket;
exports.default = _default;